import React from "react";
import RebuildMapCanvas from "@/components/navigation-rebuild/RebuildMapCanvas";
import { DEFAULT_LAYERS } from "@/components/navigation-rebuild/navigationRebuildUtils";

export default function NearMeLocationMap({ coords, places = [] }) {
  const point = [coords.latitude, coords.longitude];
  const telemetry = {
    point,
    accuracy: 35,
    heading: 0,
    speedKnots: 0,
    isEstimated: false,
    gpsStatus: "live",
    signalStrength: 3,
    timestamp: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
  };
  const layers = { ...DEFAULT_LAYERS, route: false, waypoints: false, distanceRings: true, marinas: true, seamarks: true, grid: true };
  const visiblePlaces = places.filter((place) => Number.isFinite(Number(place.latitude)) && Number.isFinite(Number(place.longitude)));

  return (
    <div className="h-[22rem] min-h-[22rem] w-full overflow-hidden bg-sky-100">
      <RebuildMapCanvas
        layers={layers}
        marinas={visiblePlaces}
        routePoints={[]}
        telemetry={telemetry}
        vesselTrace={[]}
        centerRequestKey={Date.now()}
        onCursor={() => {}}
        onAddWaypoint={() => {}}
        onDeleteWaypoint={() => {}}
      />
    </div>
  );
}